import React from 'react';
import Glyph from '@uds/glyphs';
import { Colorway, gu2px, useTheme } from '@uds/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';
import { useStyles } from '@team-griffin/stylr';
import { getBodyColor } from 'presentation/utils/colorway';

interface OuterProps {
  colorway: Colorway;
  onNavigationClick: (direction: string) => void;
}

const useStylesheet = ({ colorway }: { colorway: Colorway }) => {
  const {
    theme,
    theme: { palette, spacing },
  } = useTheme();
  return useStyles({
    default: {
      root: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      button: {
        backgroundColor: 'transparent',
        color: palette.grey02,
        outline: 0,
        borderWidth: 0,
        height: gu2px(6, spacing),
        cursor: 'pointer',
        ...cssSides('padding', Side.X, gu2px(3, spacing)),
        ...cssSides('padding', Side.Y, 0),
      },
      icon: {
        width: gu2px(3, spacing),
        color: getBodyColor(theme, colorway),
      },
    },
  });
};

const PureSalesboardNavigation = ({ onNavigationClick, colorway }: OuterProps) => {
  const { styles } = useStylesheet({
    colorway,
  });

  const onButtonClick = (direction: string) => onNavigationClick(direction);

  return (
    <div style={styles.root}>
      <button type="button" style={styles.button} onClick={() => onButtonClick('prev')}>
        <Glyph size={styles.icon.width as number} color={styles.icon.color as string} name="arrowLeft" />
      </button>
      <button type="button" style={styles.button} onClick={() => onButtonClick('next')}>
        <Glyph size={styles.icon.width as number} color={styles.icon.color as string} name="arrowRight" />
      </button>
    </div>
  );
};

PureSalesboardNavigation.displayName = 'SalesboardNavigation';

export default PureSalesboardNavigation;
